<template>
  <v-container fluid :class="mobile ? 'pa-3' : 'pa-4'">
    <v-row class="justify-center">
      <v-col sm="12" md="8" lg="6" xl="4">
        <sales-form :is-admin="isAdmin" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { onMounted, onBeforeUnmount } from "vue";
import { useDisplay } from "vuetify";
import { useRouter } from "vue-router";
import { useApp } from "@/composables/useApp.js";
import { useFilter } from "../../composables/useFilter";
import { useSalesMenu } from "@/composables/useSalesMenu.js";
import { useAppBarActions } from "@/composables/useAppBarActions.js";
import SalesForm from "@/components/SalesForm.vue";

const { mobile } = useDisplay();

const { clearFilters, applyFilters, applyDatePreset } = useFilter();
const { isAuthenticated, isAdmin, fetchOptions, options } = useApp();
const { openCoverageDialog, openImportDialog } = useSalesMenu();
const router = useRouter();
const { setActions, clearActions } = useAppBarActions();

async function handleOpenImportDialog() {
  if (!options.brands?.length) {
    await openImportDialog(fetchOptions);
  } else {
    openImportDialog();
  }
}

setActions([
  {
    icon: "mdi-file-import-outline",
    tooltip: "Import Sales Data",
    onClick: handleOpenImportDialog,
    show: isAdmin.value,
  },
  {
    icon: "mdi-chart-box-outline",
    tooltip: "Coverage Report",
    onClick: openCoverageDialog,
    show: isAdmin.value,
  },
  {
    icon: "mdi-chart-line",
    tooltip: "Sales Analytics",
    onClick: () => router.push({ name: "SalesAnalytics" }),
    show: isAdmin.value,
  },
]);

onBeforeUnmount(() => clearActions());

onMounted(async () => {
  if (isAuthenticated.value) {
    await fetchOptions();
    clearFilters();
    await applyDatePreset("7d");
    applyFilters();
  }
});
</script>
